import React from 'react';
import { observer } from 'mobx-react-lite';
import { GameBackside, GameHolder } from '@pascal/pascal-core/table-line';
import { GamePart } from '../../containers/gamePart';

export const WebGameMain = observer(() => {
  return (
    <GameHolder>
      <GameBackside />
      <GamePart />
    </GameHolder>
  );
});
